import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const HomeEmiCalculator: React.FC = () => {
    const [downPayment, setDownPayment] = useState(0);
    const [tenure, setTenure] = useState(1);
    const [rateOfInterest, setRateOfInterest] = useState(0);
    const [emi, setEmi] = useState(0);
    const navigate = useNavigate();

    const calculateEMI = () => {
        const principal = downPayment;
        const monthlyRate = rateOfInterest / 12 / 100;
        const numberOfMonths = tenure * 12;
        const emi =
            monthlyRate === 0
                ? principal / numberOfMonths
                : (principal * monthlyRate * Math.pow(1 + monthlyRate, numberOfMonths)) /
                  (Math.pow(1 + monthlyRate, numberOfMonths) - 1);
        setEmi(emi);
    };

    return (
        <div className="container">
            <h1>Home EMI Calculator</h1>
            <div className="form-group">
                <label>Down Payment:</label>
                <input
                    type="number"
                    className="form-control"
                    value={downPayment}
                    onChange={(e) => setDownPayment(Number(e.target.value))}
                />
                <input
                    type="range"
                    className="form-range"
                    min="0"
                    max="1000000"
                    step="1000"
                    value={downPayment} // Fixed: Use numeric value instead of toLocaleString()
                    onChange={(e) => setDownPayment(Number(e.target.value))}
                />
            </div>
            <div className="form-group">
                <label>Tenure (in years):</label>
                <input
                    type="number"
                    className="form-control"
                    value={tenure}
                    onChange={(e) => setTenure(Number(e.target.value))}
                />
                <input
                    type="range"
                    className="form-range"
                    min="1"
                    max="30"
                    step="1"
                    value={tenure}
                    onChange={(e) => setTenure(Number(e.target.value))}
                />
            </div>
            <div className="form-group">
                <label>Rate of Interest (%):</label>
                <input
                    type="number"
                    className="form-control"
                    value={rateOfInterest}
                    onChange={(e) => setRateOfInterest(Number(e.target.value))}
                />
                <input
                    type="range"
                    className="form-range"
                    min="0"
                    max="20"
                    step="0.1"
                    value={rateOfInterest}
                    onChange={(e) => setRateOfInterest(Number(e.target.value))}
                />
            </div>
            <div className="form-group mt-3">
                <button
                    className="btn btn-primary"
                    onClick={() => {
                        calculateEMI();
                    }}
                >
                    Calculate EMI
                </button>
            </div>
            
            <div className="result mt-3">
                <p>
                    <strong>EMI:</strong> {emi.toFixed(2)}
                </p>
            </div>
        </div>
    );
};
export default HomeEmiCalculator;